<ng-template #IPchecking>{{ 'login-Page.checking' | translate }}</ng-template>

<div class="hub-wrapper container-fluid">
    <div class="top-horizontal-ad">
        <app-ad-container adType="TOP"></app-ad-container>
    </div>
    <div *ngIf="layout.isWeb$ | async">
        <div class="hub-container col-xxl-10 col-xl-10 col-lg-12 col-md-12">
            <div class="hub-top-grid">
                <div class="hub-panel shortages">
                    <app-drug-shortages-panel></app-drug-shortages-panel>
                </div>
                <div class="hub-panel cpj">
                    <app-cpj-container></app-cpj-container>
                </div>
                <div class="hub-panel goToCPS">
                    <app-go-to-cps-panel></app-go-to-cps-panel>
                </div>
            </div>
            <div class="hub-mid-grid">
                <div class="hub-panel">
                    <app-continuing-education-panel></app-continuing-education-panel>
                </div>
                <div class="hub-panel">
                    <app-events-panel></app-events-panel>
                </div>
                <div class="top-vertical-ad">
                    <app-ad-container adType="SIDE"></app-ad-container>
                </div>
            </div>
            <div class="hub-bot-grid">
                <div class="hub-panel">
                    <app-insights-panel></app-insights-panel>
                </div>
                <!-- <div class="hub-panel">
                <app-linkedin-container></app-linkedin-container>
            </div> -->
                <div class="hub-panel">
                    <app-practice-resources-panel></app-practice-resources-panel>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="layout.isTablet$ | async">
        <div class="hub-container">
            <div class="hub-top-grid">
                <div class="hub-panel shortages">
                    <app-drug-shortages-panel></app-drug-shortages-panel>
                </div>
                <div class="hub-panel goToCPS">
                    <app-go-to-cps-panel></app-go-to-cps-panel>
                </div>
            </div>
            <div class="hub-mid-grid">

                <div class="left">
                    
                    <div class="hub-panel cpj">
                        <app-cpj-container></app-cpj-container>
                    </div>
                    <div class="hub-panel">
                        <app-continuing-education-panel></app-continuing-education-panel>
                    </div>                    
                    
                </div>
        
                <div class="right">
                    <div class="top-vertical-ad">
                        <app-ad-container adType="SIDE"></app-ad-container>
                    </div>    
                </div>
            </div>
            
            <div class="hub-mid-bot-grid">
                <div class="left">                    
                    <div class="hub-panel">
                        <app-practice-resources-panel></app-practice-resources-panel>
                    </div>
                </div>
        
                <div class="right">
                    <div class="hub-panel">
                        <app-events-panel></app-events-panel>
                    </div>  
                </div>
            </div>
            <div class="hub-bot-grid">
                <!-- <div class="hub-panel"> Removed until phase 2
                    <app-linkedin-container></app-linkedin-container>
                </div> -->
                <div class="hub-panel">
                    <app-insights-panel></app-insights-panel>
                </div>                
            </div>
        </div>
    </div>

    <div *ngIf="layout.isHandset$ | async">
        <div class="hub-mobile-container">
      
            <div class="hub-panel">
                <app-go-to-cps-panel></app-go-to-cps-panel>
            </div>
            
            <div class="hub-panel">
                <app-drug-shortages-panel></app-drug-shortages-panel>
            </div>
      
            <div class="hub-panel">
                <app-cpj-container></app-cpj-container>
            </div>
            
            <div class="hub-panel">
                <app-ad-container adType="SIDE"></app-ad-container>
            </div>
      
            <div class="hub-panel">
                <app-continuing-education-panel></app-continuing-education-panel>
            </div>
      
            <div class="hub-panel">
                <app-events-panel></app-events-panel>
            </div>
      
            <div class="hub-panel">
                <app-practice-resources-panel></app-practice-resources-panel>
            </div>
      
            <div class="hub-panel">
                <app-insights-panel></app-insights-panel>
            </div>
      
        </div>
    </div>
</div>